module.exports = __webpack_public_path__ + "assets/img/3_1204_big.c40cb7f3.jpg";